<template lang="html">
	<form class="form-ui column default-form-ui" novalidate>
		<div class="title">
			Documents liés à l'abonnement
		</div>
		<div class="ctn-docs row">
			<div class="ctn-doc">
				<div class="tile-doc row">
					<span class="icon-document-pdf"></span>
					<div class="text">
						<div class="label">
							Contrat d'abonnement
						</div>
						<div class="name">
							{{ (subscriptionContract) ? subscriptionContract.original_name : 'Pas de fichier' }}
						</div>
					</div>
					<input id="lmfile" type="file" class="hidden" @change="uploadSubscriptionContractFile">
				</div>
				<div class="ctn-actions row">
					<div class="btn btn-red ctn-icon" :class="{'btn-disabled': !hasIdentityCertificated}" v-if="needForSign(subscriptionContract)" @click="askForSignature(subscriptionContract)">
						Soumettre une signature
					</div>
					<div class="btn btn-red ctn-icon" v-if="canLoad(subscriptionContract)" @click="procUpload('lmfile')">
						<span class="icon-button-download"></span>
						Charger un fichier
					</div>
					<div class="status row" v-if="subscriptionContract && !needForSign(subscriptionContract) && subscriptionContract.universign_launch_date">
						Ajouté le {{ subscriptionContract.universign_launch_date.split(' ')[0]}}
						<span class="green inner-status" v-if="subscriptionContract.universign_status === 'completed'">Signé le {{ subscriptionContract.signature_date.split(' ')[0] }}</span>
						<span class="orange inner-status" v-if="subscriptionContract.universign_status === 'ready'">Signature en attente</span>
					</div>
				</div>
				<p v-show="!hasIdentityCertificated" class="text-red"><br><small><i class="icon-bandeau-alert"></i> L'identité du client doit être vérifiée avant de lui soumettre une signature.
							<router-link :to="{name: 'Client', params: { clientId: subscription.user.id}}" class="link">Vérifier son identité</router-link>
				</small>
				</p>
				<div class="other-actions row" v-if="subscriptionContract">
					<div class="link" v-if="subscriptionContract.universign_status === 'ready'" @click="callVerify(subscriptionContract)">
						Vérifier
					</div>
					<div class="link" v-if="subscriptionContract.universign_status === 'ready'" @click="relaunchTransaction(subscriptionContract)">
						Envoyer un mail de relance
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import UniversignResource from '@/common/resources/Universign'
import TileDoc from '@/common/components/tile-doc'

export default {
	name: 'EditDocs',
	props: ['subscription'],
	components: {
		TileDoc
	},
	data () {
		return {
			subscriptionContract: null
		}
	},
	mounted () {
		this.initSubscriptionDocuments()
	},
	methods: {
		initSubscriptionDocuments () {
			this.subscriptionContract = this.subscription.subcription_contract_document
		},
		uploadSubscriptionContractFile (e) {
			let file = e.target.files[0]
			let type = this.resolveType(file.type)
			if (type) {
				this.$store.dispatch('addDocument', {
					subscription_id: this.subscription.id,
					user_id: this.subscription.user.id,
					category: 'subscriptions',
					type: file.type.replace('application/', ''),
					file: file,
					subcategory: 'Contrat d\'abonnement',
					signature_required: true,
					signature_token: null,
					original_name: 'contract_abonnement_' + this.$moment().format('DD-MM-YYYY'),
					confidential: 0
				}).then(() => {
					this.$emit('needToUpdate')
					this.$notify({
						type: 'success',
						group: 'default',
						title: 'Contrat d\'abonnement ajouté avec succès',
						text: ''
					})
				}).catch(() => {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					})
				})
			}
		},
		canLoad (doc) {
			return !doc || (!doc.universign_status || doc.universign_status === 'null' || doc.universign_status === undefined)
		},
		needForSign (doc) {
			return doc &&
			(!doc.universign_status || doc.universign_status === 'null' || doc.universign_status === undefined)
		},
		procUpload (id) {
			document.getElementById(id).click()
		},
		resolveType (t) {
			let value = null
			switch (t) {
			case 'application/pdf':
				value = 'pdf'
				break
			case 'application/octet-stream':
				value = 'txt'
				break
			case 'application/msword':
				value = 'doc'
				break
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
				value = 'docx'
				break
			case 'application/vnd.ms-excel':
				value = 'xls'
				break
			case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
				value = 'xlsx'
				break
			default:
				value = false
			}

			return value
		},
		askForSignature (doc) {
			if (!this.hasIdentityCertificated) {
				return
			}

			const func = UniversignResource.signSubscriptionContract
			const id = doc.id

			func(id).then((result) => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Demande de signature envoyé avec succès',
					text: 'Un mail a été envoyé à votre client'
				})
				this.$emit('needToUpdate')
			}).catch((error) => {
				console.warn(error)
			})
		},
		callVerify (doc) {
			this.$store.commit('LOADER_IN')
			UniversignResource.verify(doc.universign_transaction_id).then((result) => {
				this.$store.commit('LOADER_OUT')
				if (result.data.success) {
					doc.universign_status = result.data.universign_status
				}
			}).catch((error) => {
				this.$store.commit('LOADER_OUT')
				console.warn(error)
			})
		},
		relaunchTransaction (doc) {
			this.$store.commit('LOADER_IN')
			UniversignResource.relaunchTransaction(doc.universign_transaction_id).then((result) => {
				this.$store.commit('LOADER_OUT')
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Mail de relance envoyé avec succès',
					text: ''
				})
			}).catch((error) => {
				this.$store.commit('LOADER_OUT')
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: ''
				})
				console.warn(error)
			})
		}
	},
	watch: {
		subscription () {
			this.initSubscriptionDocuments()
		}
	},
	computed: {
		hasIdentityCertificated () {
			return this.subscription && this.subscription.user.certified === 1
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Docs.vue?a13213a4